export const MfoFullDealTexts = {
  amount: 'Мне нужно',
  period: 'Срок',
  snils: 'СНИЛС',
};

export const BUTTON_LABEL = 'Далее';

export const NOTIFICATION_ERROR = {
  type: 'error',
  title: 'Произошла ошибка',
  message: 'Попробуйте позже',
} as const;
